import { cn } from '@/lib/utils';

interface StoreCardBadgesProps {
  isNew: boolean;
  orderAvailable: boolean;
  onFavoriteClick: (e: React.MouseEvent) => void;
  favoriteState: boolean;
  layout?: 'vertical' | 'horizontal';
  deadlineStockBadgeText?: string | null;
  orderType?: 'DEADLINE_DISCOUNT' | 'RESERVATION_DISCOUNT' | 'REGULAR_ORDER';
}

export function StoreCardBadges({
  isNew,
  orderAvailable,
  onFavoriteClick,
  favoriteState,
  layout = 'vertical',
  deadlineStockBadgeText,
  orderType
}: StoreCardBadgesProps) {
  const orderStatusText = orderAvailable
    ? '주문가능'
    : orderType === 'DEADLINE_DISCOUNT'
      ? '오픈대기'
      : '주문마감';

  if (layout === 'horizontal') {
    return (
      <div className="absolute top-2 left-2 flex flex-col gap-1">
        {isNew && (
          <div className="bg-[#FF6D00] text-[#222222] text-[14px]" style={{ padding: '4px', borderRadius: '8px', fontWeight: '500' }}>
            New!
          </div>
        )}
        <div className={cn(
          "text-[14px] font-medium text-[#222222]",
          orderAvailable 
            ? "bg-[#FFEFE0]"
            : "bg-[#999999] text-white"
        )} style={{ padding: '4px', borderRadius: '8px' }}>
          {orderStatusText}
        </div>
        {deadlineStockBadgeText && (
          <div className={cn(
            "text-[13px] font-semibold",
            deadlineStockBadgeText === '품절' ? 'bg-[#999999] text-white' : 'bg-[#E6F7E6] text-[#2E7D32]'
          )} style={{ padding: '4px 6px', borderRadius: '8px' }}>
            {deadlineStockBadgeText}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="absolute flex items-center justify-between" style={{ top: '8px', left: '12px', right: '12px' }}>
      {/* 좌측 배지들 */}
      <div className="flex items-center" style={{ gap: '12px' }}>
        {/* 주문가능 배지 */}
        <div className={cn(
          "text-[14px] font-medium text-[#222222]",
          orderAvailable 
            ? "bg-[#FFEFE0]"
            : "bg-[#999999] text-white"
        )} style={{ padding: '4px', borderRadius: '8px' }}>
          {orderStatusText}
        </div>
        
        {/* New 배지 */}
        {isNew && (
          <div className="bg-[#FF6D00] text-[#FFFFFF] text-[14px]" style={{ padding: '4px', borderRadius: '8px', fontWeight: '700' }}>
            New!
          </div>
        )}

        {/* 마감할인 잔여수량 배지 */}
        {deadlineStockBadgeText && (
          <div className={cn(
            "text-[13px] font-semibold",
            deadlineStockBadgeText === '품절' ? 'bg-[#999999] text-white' : 'bg-[#E6F7E6] text-[#2E7D32]'
          )} style={{ padding: '4px 6px', borderRadius: '8px' }}>
            {deadlineStockBadgeText}
          </div>
        )}
      </div>

      {/* 우측 즐겨찾기 별 */}
      <button
        onClick={onFavoriteClick}
        className="w-8 h-8 flex items-center justify-center bg-transparent border-none p-0"
        style={{ filter: 'none' }}
      >
        <img 
          src={favoriteState ? "/icons/icon_favorites_selected.svg" : "/icons/icon_favorites.svg"}
          alt="즐겨찾기"
          style={{ 
            width: '32px',
            height: '32px',
            filter: favoriteState ? 'brightness(0) saturate(100%) invert(43%) sepia(96%) saturate(1352%) hue-rotate(87deg) brightness(119%) contrast(119%)' : 'brightness(0) saturate(100%) invert(100%)'
          }}
        />
      </button>
    </div>
  );
}

export function HorizontalFavoriteButton({
  onFavoriteClick,
  favoriteState
}: {
  onFavoriteClick: (e: React.MouseEvent) => void;
  favoriteState: boolean;
}) {
  return (
    <button
      onClick={onFavoriteClick}
      className="absolute top-2 right-2 w-8 h-8 bg-transparent border-none p-0"
    >
      <img 
        src={favoriteState ? "/icons/icon_favorites_selected.svg" : "/icons/icon_favorites.svg"}
        alt="즐겨찾기"
        style={{ 
          width: '32px',
          height: '32px',
          filter: favoriteState ? 'brightness(0) saturate(100%) invert(43%) sepia(96%) saturate(1352%) hue-rotate(87deg) brightness(119%) contrast(119%)' : 'brightness(0) saturate(100%) invert(100%)'
        }}
      />
    </button>
  );
}
